import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import { FormSelect } from '../../../../../../../styledComponents/UI/Form/FormSelect/FormSelect';
import { getFieldPropertiesForGroup } from '../../../../../../../utils/getFormGroupPath';

import { IOrganizationSearch } from '../../../../../../../models/interfaces/SearchOrganization';
import { formatDate } from '../../../../../../../utils/dateHelpers';
import { FormColumn } from '../../../../../../../styledComponents/UI/Form/FormColumn/FormColumn';
import { FormRow } from '../../../../../../../styledComponents/UI/Form/FormRow/FormRow';
import FormDatePicker from '../../../../../../../styledComponents/UI/Form/FormDatePicker/FormDatePicker';
import { FormSelectAsync } from '../../../../../../../styledComponents/UI/Form/FormSelectAsync/FormSelectAsync';

import FormValue from '../../../../../../../styledComponents/UI/Form/FormValue/FormValue';

import { CustomForm } from '../../../../../../../models/types/CustomForm';
import {
  formName,
  DOCMembershipOrganizationDetailsFormFields,
} from './docMembershipDetailsForm.models';
import { useDOCMembershipDetails } from './docMembershipDetailsForm.hooks';
import {
  StyledFormMessage,
  StyledSectionWrapper,
} from './docMembershipDetailsForm.styles';

const SRMembershipDetailsForm = ({ className, disabled }: CustomForm) => {
  const { t } = useTranslation();
  const {
    subscriptionsOptions,
    organizationsPromiseOptions,
    currentPackage,
    availableSeats,
  } = useDOCMembershipDetails();

  return (
    <StyledSectionWrapper className={className}>
      <FormColumn>
        <FormRow isSubRow>
          <Field
            component={FormSelectAsync}
            isClearable
            disabled={disabled}
            label={t('fields.organizationName.label')}
            labelSelector={(value: IOrganizationSearch) => value.name}
            {...getFieldPropertiesForGroup({
              inputId: formName,
              name: DOCMembershipOrganizationDetailsFormFields.Organization,
            })}
            placeholder={t('fields.organizationName.placeholder')}
            promiseOptions={organizationsPromiseOptions}
          />
          <Field
            component={FormSelect}
            disabled={disabled}
            isLabelHidden
            {...getFieldPropertiesForGroup({
              inputId: formName,
              name: DOCMembershipOrganizationDetailsFormFields.SubscriptionType,
            })}
            options={subscriptionsOptions}
            placeholder={t('fields.subscriptionType.placeholder')}
            setDefaultValue
          />
        </FormRow>
        <FormRow isSubRow>
          <FormRow isSubRow>
            <Field
              label={t('fields.packageType.label')}
              component={FormValue}
              contentVisible
              {...getFieldPropertiesForGroup({
                inputId: formName,
                name: DOCMembershipOrganizationDetailsFormFields.PackageType,
              })}
              externalValue={currentPackage}
            />
          </FormRow>
          <FormRow isSubRow>
            <Field
              component={FormDatePicker}
              disabled={disabled}
              {...getFieldPropertiesForGroup({
                inputId: formName,
                name: DOCMembershipOrganizationDetailsFormFields.EffectiveDate,
              })}
            />
            <Field
              label={t('fields.expirationDate.label')}
              component={FormValue}
              contentVisible
              {...getFieldPropertiesForGroup({
                inputId: formName,
                name: DOCMembershipOrganizationDetailsFormFields.ExpirationDate,
              })}
              valueRenderer={(value: string) => formatDate(value)}
            />
          </FormRow>
        </FormRow>
      </FormColumn>
      {availableSeats && (
        <StyledFormMessage
          message={t(
            availableSeats > 0
              ? 'phrase.seats_remaining'
              : 'phrase.seats_remaining_add_required',
            {
              value: availableSeats,
            },
          )}
          status={availableSeats > 0 ? 'success' : 'warning'}
        />
      )}
    </StyledSectionWrapper>
  );
};

export default SRMembershipDetailsForm;
